import { Radio, RadioGroup, Stack, useColorModeValue } from '@ecoinvent/ui';

import StepHeader from '../components/StepHeader';
import { EXPERIENCE_OPTIONS } from '../constants';

interface ExperienceStepProps {
  value: string | null;
  onChange: (value: string) => void;
}

const ExperienceStep = ({ value, onChange }: ExperienceStepProps) => {
  const borderColor = useColorModeValue('gray.200', 'gray.600');

  return (
    <Stack spacing={8} align="center" w="100%">
      <StepHeader step={1} totalSteps={3} title="What is your experience with environmental databases?" />
      <RadioGroup value={value ?? ''} onChange={onChange}>
        <Stack spacing={3}>
          {EXPERIENCE_OPTIONS.map((option) => (
            <Radio
              key={option.value}
              value={option.value}
              colorScheme="green"
              size="lg"
              borderColor={borderColor}
              sx={{
                '& .chakra-radio__control': {
                  borderWidth: '2px',
                  _checked: {
                    bg: 'green.500',
                    borderColor: 'green.500',
                    _before: {
                      content: '""',
                      display: 'inline-block',
                      w: '40%',
                      h: '40%',
                      borderRadius: '50%',
                      bg: 'white',
                    },
                    _hover: {
                      bg: 'green.600',
                      borderColor: 'green.600',
                    },
                  },
                },
              }}
            >
              {option.label}
            </Radio>
          ))}
        </Stack>
      </RadioGroup>
    </Stack>
  );
};

export default ExperienceStep;
